module.exports = __webpack_public_path__ + "static/media/Valvulas-Control-02.97e8de11.jpg";